import axios from "axios"
import client from "./http.client"
import store from "@/store"
import { utils } from "@/store/helpers"

class DataService {
  createOrganization(data) {
    return client.post(`/api/organizations/create-organization/`, data)
  }

  joinOrganization(id) {
    return client.post(`/api/organizations/${id}/join-organization/`)
  }

  deleteOrganization(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/delete-organization/`, data)
  }

  leaveOrganization(id) {
    return client.post(`/api/organizations/${id}/leave-organization/`)
  }

  getOrganizations(data) {
    return client.get(`/api/organizations/all-organizations/`, data)
  }

  checkOrganizationName(name) {
    return client.get(`/api/organizations/check-name?name=${name}`)
  }

  getSurveys(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/surveys/`, { params })
  }

  getSurveyDetail(id) {
    return client.get(`/api/organizations/${store.state.organization.id}/surveys/${id}/`)
  }

  editSurvey(id, data) {
    return client.patch(`/api/organizations/${store.state.organization.id}/surveys/${id}/`, data)
  }

  getInsights(domain, name) {
    return client.get(`/api/ai/insights/?domain=${domain}&name=${name}&token=fafa310a2c28d9de4072f5c42970f747267afd74`)
  }

  addRecord(domain_name) {
    return client.post(`/api/organizations/${store.state.organization.id}/records/add-record/`, { domain_name })
  }

  deleteSurvey(id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/surveys/${id}/`)
  }

  getSurveyResponses(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/surveys/${id}/responses/`, { params })
  }

  createSurvey(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/surveys/`, data)
  }

  sendSurvey(id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/surveys/${id}/send/`, data)
  }

  getFilteredContacts(e, params, parents = []) {
    const data = {
      filter: [
        store.state.integration.metrics_mapping.contact_first_name_metric,
        "in",
        `'${e?.split(" ")[0]}'`,
        e?.split(" ").length > 1 && e?.split(" ")[1] ? "and" : "or",
        store.state.integration.metrics_mapping.contact_last_name_metric,
        "in",
        `'${e?.split(" ").length > 1 && e.split(" ")[1] ? e?.split(" ")[1] : e}'`,
        "or",
        store.state.integration.metrics_mapping.contact_email_metric,
        "in",
        `'${e?.split(" ")[0]}'`
      ].join(" "),
      parents: parents,
      object_types: ["contact"]
    }
    return client.post(`/api/organizations/${store.state.organization.id}/records/filter/`, data, { params })
  }

  getFilteredCompaniesAndOrOpportunities(e, getOppsToo, typeFilter) {
    let data = null

    if (typeFilter) {
      data = {
        filter: [`${store.state.integration.metrics_mapping[`${typeFilter}_name_metric`]}`, "in", `'${e}'`].join(" "),
        object_types: [typeFilter]
      }
    } else {
      data = {
        filter: getOppsToo
          ? [
              store.state.integration.metrics_mapping.company_name_metric,
              "in",
              `'${e}'`,
              "or",
              store.state.integration.metrics_mapping.opportunity_name_metric,
              "in",
              `'${e}'`
            ].join(" ")
          : [store.state.integration.metrics_mapping.company_name_metric, "in", `'${e}'`].join(" "),
        object_types: getOppsToo ? ["company", "opportunity"] : ["company"]
      }
    }
    return client.post(`/api/organizations/${store.state.organization.id}/records/filter/`, data)
  }

  getFilteredRecords(e, getOppsToo) {
    const data = {
      filter: getOppsToo
        ? [
            store.state.integration.metrics_mapping.company_name_metric,
            "in",
            `'${e}'`,
            "or",
            store.state.integration.metrics_mapping.opportunity_name_metric,
            "in",
            `'${e}'`
          ].join(" ")
        : [store.state.integration.metrics_mapping.company_name_metric, "in", `'${e}'`].join(" "),
      object_types: getOppsToo ? ["company", "opportunity"] : ["company"]
    }
    return client.post(`/api/organizations/${store.state.organization.id}/records/filter/`, data)
  }

  getSavedList() {
    return client.get(`/api/organizations/${store.state.organization.id}/saved-filters/`)
  }
  addToSavedList(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/saved-filters/`, data)
  }
  deleteFromSavedList(id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/saved-filters/${id}`)
  }

  getCalendarRanges(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/interactions/range-interactions/`, data)
  }

  //MetricColors
  getMetricColors() {
    return client.get(`/api/organizations/${store.state.organization.id}/metrics-color-ranges/`)
  }
  createMetricColors(ranges) {
    return client.post(`/api/organizations/${store.state.organization.id}/metrics-color-ranges/`, ranges)
  }
  editMetricColors(id, data) {
    return client.put(`/api/organizations/${store.state.organization.id}/metrics-color-ranges/${id}/`, data)
  }

  /**
   * Add Team
   * @param {Team} team - Team.
   */
  addOrganizationTeam(team) {
    return client.post(`/api/organizations/${store.state.organization.id}/teams/`, team)
  }
  /**
   *
   * @param {Team} team
   * @returns list of teams
   */

  getOrganizationTeams() {
    return client.get(`/api/organizations/${store.state.organization.id}/teams/`)
  }
  /**
   * Add Team
   * @param {Team} team - Team.
   * @return {Promise}
   */
  updateOrganizationTeam(team) {
    return client.patch(`/api/organizations/${store.state.organization.id}/teams/${team.id}/`, team)
  }
  deleteOrganizationTeam(id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/teams/${id}/`)
  }
  getOrganizationUsers(params = { page_size: 25 }) {
    return client.get(`/api/organizations/${store.state.organization.id}/users/`, { params })
  }
  getOrganizationResources() {
    return client.get(`/api/organizations/${store.state.organization?.id}/resources/`)
  }
  getOrganizationSFUsersWithCompanies() {
    return client.get("/api/organizations/sf-users-and-records/")
  }
  getOrganizationNestedMetrics() {
    return client.get(`/api/organizations/${store.state.organization.id}/metrics/get-nested-metrics/`)
  }
  getOrganizationSources(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/sources/`, { params })
  }
  addOrganizationMetric(metric) {
    return client.post(`/api/organizations/${store.state.organization.id}/metrics/`, metric)
  }
  isFormulaValid(metric) {
    return client.post(`/api/organizations/${store.state.organization.id}/metrics/validate-formula/`, metric)
  }
  getOrganizationMetrics(params = { page_size: 25 }) {
    return client.get(`/api/organizations/${store.state.organization.id}/metrics/`, { params })
  }
  getOrganizationMetric(metric_id) {
    return client.get(`/api/organizations/${store.state.organization.id}/metrics/${metric_id}/`)
  }
  deleteOrganizationMetric(metric_id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/metrics/${metric_id}/`)
  }
  updateOrganizationMetric(metric) {
    return client.patch(`/api/organizations/${store.state.organization.id}/metrics/${metric.id}/`, metric)
  }
  getPortfolio() {
    return client.get(`/api/organizations/${store.state.organization.id}/portfolio/primary/`)
  }
  getPortfolios(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/portfolio/`, { params })
  }
  // use this to update the portfolio metrics
  // metrics_summary_list:[list of metrics ids you wanna include]
  // table_metrics_list:[list 1`of metrics ids you wanna include]
  updatePortfolio(data, params = {}) {
    return client.patch(`/api/organizations/${store.state.organization.id}/portfolio/primary/`, data, { params })
  }
  updateUserPortfolio(id, data, params = {}) {
    return client.patch(`/api/organizations/${store.state.organization.id}/portfolio/${id}/`, data, { params })
  }
  cloneLayoutToUsers(data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/portfolio/clone-layout/`, data, { params })
  }
  updateLayout(data) {
    return client.patch(`/api/organizations/${store.state.organization.id}/portfolio/primary/update-layout/`, data)
  }

  getRecords(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/records/`, { params })
  }
  getRecordChildren(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/records/${id}/children/`, { params })
  }

  getContactsForGroup(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/groups/${id}/children/`, { params })
  }

  filterRecords(data, params = {}, trancute_by) {
    if (data.filter) {
      data.filter = utils.convertFiltersFromLocalDateToUtc(data.filter, trancute_by)
    }

    return client.post(`/api/organizations/${store.state.organization.id}/records/filter/`, data, { params })
  }

  exportRecords(data, params = {}) {
    if (data.filter) {
      data.filter = utils.convertFiltersFromLocalDateToUtc(data.filter)
    }

    return client.post(`/api/organizations/${store.state.organization.id}/records/export/`, data, { params })
  }

  fastRecordsSearch(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/records/`, { params })
  }
  // Companies endpoints

  // async axios call to any endpoint
  async getRecordsByUrl(url, filter = null, params = {}) {
    if (filter && Object.keys(filter).length) {
      return client.post(url, filter, { params })
    } else {
      return client.get(url, { params })
    }
  }

  callEndpointByUrl(url, params = {}, method = "get") {
    if (method == "post") {
      return client.post(url, params)
    } else {
      return client.get(url, { params })
    }
  }

  // get record by id[uuid]
  // not that this endpoint gets the values of the metrics of the record profile_metrics_values
  getRecord(id) {
    let uid = id
    // Some one did this not Moussa because he was too lazy to fix his logic
    if (typeof id != "string") {
      uid = id?.id
    }
    return client.get(`/api/organizations/${store.state.organization.id}/records/${uid}/`)
  }

  // update record
  updateRecord(id, data, params = {}) {
    return client.patch(`/api/organizations/${store.state.organization.id}/records/${id}/`, data, { params })
  }
  updateRecordMetric(record_id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/records/${record_id}/update-metric-value/`, data)
  }
  createRecord(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/records/`, data)
  }
  deleteRecord(id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/records/${id}/`)
  }

  // assign records owner
  assignCompaniesOwner(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/records/bulk-owner-assign/`, data)
  }
  assignCompaniesCoOwners(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/records/bulk-co-owners-assign/`, data)
  }
  unassignCompaniesCoOwners(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/records/bulk-co-owners-unassign/`, data)
  }

  bulkRecordsDelete(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/records/bulk-records-delete/`, data)
  }
  bulkRecordsMetricUpdate(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/records/bulk-metric-update/`, data)
  }
  mergeMetricsValues(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/records/merge-metrics/`, data)
  }

  // Goals endpoints

  // fetching all goals
  getUserGoals(id) {
    return client.get(`/api/users/${id}/goals/`)
  }

  // fetching one goal
  getUserGoal(id, goal_id) {
    return client.get(`/api/users/${id}/goals/${goal_id}`)
  }

  // fetching one goal
  updateUserGoal(id, goal_id, data, params = {}) {
    return client.get(`/api/users/${id}/goals/${goal_id}`, data, { params })
  }

  getExpansionLists(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/expansions/`, { params })
  }
  getExpansionList(id, params) {
    return client.get(`/api/organizations/${store.state.organization.id}/expansions/${id}/`, { params })
  }

  deleteExpansionList(id, params) {
    return client.delete(`/api/organizations/${store.state.organization.id}/expansions/${id}/`, { params })
  }
  createExpansionList(data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/expansions/`, data, { params })
  }
  updateExpansionList(id, data, params = {}) {
    return client.patch(`/api/organizations/${store.state.organization.id}/expansions/${id}/`, data, { params })
  }
  createTag(data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/tags/`, data, { params })
  }
  updateTag(id, data, params = {}) {
    return client.patch(`/api/organizations/${store.state.organization.id}/tags/${id}/`, data, { params })
  }
  getTags() {
    return client.get(`/api/organizations/${store.state.organization.id}/tags/`)
  }
  deleteTag(id, params = {}) {
    return client.delete(`/api/organizations/${store.state.organization.id}/tags/${id}`, { params })
  }
  createActionsTag(data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/actions-tags/`, data, { params })
  }
  updateActionsTag(id, data, params = {}) {
    return client.patch(`/api/organizations/${store.state.organization.id}/actions-tags/${id}/`, data, { params })
  }
  getActionsTags() {
    return client.get(`/api/organizations/${store.state.organization.id}/actions-tags/`)
  }
  deleteActionsTag(id, params = {}) {
    return client.delete(`/api/organizations/${store.state.organization.id}/actions-tags/${id}`, { params })
  }
  bulkTagAssign(data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/tags/bulk-tag-assign/`, data, { params })
  }
  bulkTagsAssign(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/records/bulk-tags-assign/`, data)
  }
  bulkTagsUnassign(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/records/bulk-tags-unassign/`, data)
  }
  // groups endpoint
  getGroups(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/groups/`, { params })
  }
  getGroup(id) {
    return client.get(`/api/organizations/${store.state.organization.id}/groups/${id}/`)
  }
  getGroupRollupMetrics(id) {
    return client.get(`/api/organizations/${store.state.organization.id}/groups/${id}/rollup-metrics/`)
  }
  getGroupCompanies(id) {
    return client.get(`/api/organizations/${store.state.organization.id}/groups/${id}/records/`)
  }
  /*
    object_type: contact,opportunity ..
    nested_level = 1 more than two will fetch the groups companies contacts[object_type] and their children contacts[object_type]
  */
  getGroupCompaniesChildren(id, object_type = "contact", params = { nest_level: 1 }) {
    return client.get(`/api/organizations/${store.state.organization.id}/groups/${id}/${object_type}/`, { params })
  }
  deleteGroup(id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/groups/${id}/`)
  }
  createGroup(data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/groups/`, data, { params })
  }
  updateGroup(id, data, params = {}) {
    return client.patch(`/api/organizations/${store.state.organization.id}/groups/${id}/`, data, { params })
  }

  // goals endpoint
  getGoals(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/goals/`, { params })
  }
  getGoal(id) {
    return client.get(`/api/organizations/${store.state.organization.id}/goals/${id}/`)
  }
  removeGoal(id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/goals/${id}/`)
  }
  createGoal(data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/goals/`, data, { params })
  }

  createUserNote(user_id, data) {
    return client.post(`/api/users/${user_id}/notes/`, data)
  }

  updateUserNote(user_id, note_id, data) {
    return client.patch(`/api/users/${user_id}/notes/${note_id}/`, data)
  }

  bulkGoalCreate(data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/goals/bulk-goal-create/`, data, { params })
  }
  updateGoal(id, data, params = {}) {
    return client.patch(`/api/organizations/${store.state.organization.id}/goals/${id}/`, data, { params })
  }

  // plans endpoint
  getPlans(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/plans/`, { params })
  }
  getPlan(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/plans/${id}/`, { params })
  }
  removePlan(id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/plans/${id}/`)
  }
  createPlan(data, params = {}, headers = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/plans/`, data, { params: params, headers: headers })
  }

  // Templates endpoint
  getTemplates(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/templates/`, { params })
  }
  getTemplate(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/templates/${id}/`, { params })
  }
  removeTemplate(id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/templates/${id}/`)
  }
  createTemplate(data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/templates/`, data, { params: params })
  }
  updateTemplate(id, data, params = {}) {
    return client.patch(`/api/organizations/${store.state.organization.id}/templates/${id}/`, data, { params: params })
  }
  duplicateTemplate(id, data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/templates/${id}/duplicate/`, data, { params: params })
  }

  // Milestones endpoint
  getMilestones(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/milestones/`, { params })
  }
  getMilestone(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/milestones/${id}/`, { params })
  }

  subscribeToStripe(data) {
    return client.post(`/api/users/subscribe-to-stripe/`, data)
  }

  billingProducts() {
    return client.get(`/api/billing/products`)
  }

  cancelSubscription(data) {
    return client.post(`/api/users/cancel-subscription/`, data)
  }
  cancelFutureCancellation(data) {
    return client.post(`/api/users/uncancel-subscription/`, data)
  }
  mySubscriptions() {
    return client.get(`/api/users/my-subscriptions/`)
  }

  stripeCustomerPortal(data) {
    return client.post(`/api/users/stripe-customer-portal-url/`, data)
  }

  prepareStripeCheckoutForUpdate(data) {
    return client.post(`/api/users/prepare-stripe-checkout-for-update/`, data)
  }

  removeMilestone(id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/milestones/${id}/`)
  }
  createMilestone(data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/milestones/`, data, { params: params })
  }
  updateMilestone(id, data, params = {}) {
    return client.patch(`/api/organizations/${store.state.organization.id}/milestones/${id}/`, data, { params: params })
  }

  getMilestonesSteps(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/milestones-steps/`, { params })
  }
  getStep(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/milestones-steps/${id}/`, { params })
  }
  getMilestoneSteps(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/milestones/${id}/steps/`, { params: params })
  }
  removeMilestoneStep(id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/milestones/${id}/remove-steps/`, data)
  }
  createMilestoneStep(id, data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/milestones/${id}/steps/`, data, { params: params })
  }
  addMilestoneStep(id, data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/milestones/${id}/add-steps/`, data, { params: params })
  }
  updateMilestoneStep(id, data, params = {}) {
    return client.patch(`/api/organizations/${store.state.organization.id}/milestones-steps/${id}/`, data, { params: params })
  }
  createStandAloneMilestoneStep(data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/milestones-steps/`, data, { params: params })
  }

  getGoalsFromMilestoneStep(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/milestones-steps/${id}/goals/`, { params })
  }

  addGoalToMilestoneStep(id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/milestones-steps/${id}/add-goals/`, data)
  }
  removeGoalFromMilestoneStep(id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/milestones-steps/${id}/remove-goals/`, data)
  }

  getTasksFromMilestoneStep(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/milestones-steps/${id}/tasks/`, { params })
  }
  addTaskToMilestoneStep(id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/milestones-steps/${id}/add-tasks/`, data)
  }
  removeTaskFromMilestoneStep(id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/milestones-steps/${id}/remove-tasks/`, data)
  }

  getMilestoneStepNotes(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/milestones-steps/${id}/notes/`, { params })
  }
  addNoteToMilestoneStep(id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/milestones-steps/${id}/add-notes/`, data)
  }
  removeNoteFromMilestoneStep(id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/milestones-steps/${id}/remove-notes/`, data)
  }

  addAttachmentsToPlan(id, data, params) {
    return client.post(`/api/organizations/${store.state.organization.id}/plans/${id}/attachments/`, data, {
      params: params,
      headers: { "Content-Type": "multipart/form-data" }
    })
  }
  deleteAttachmentsFromPlan(id, data, params) {
    return client.post(
      `/api/organizations/${store.state.organization.id}/plans/${id}/attachments/`,
      { ...data, delete: true },
      { params: params }
    )
  }

  addAttachmentsToGoal(id, data, params) {
    return client.post(`/api/organizations/${store.state.organization.id}/goals/${id}/attachments/`, data, {
      params: params,
      headers: { "Content-Type": "multipart/form-data" }
    })
  }
  deleteAttachmentsFromGoal(id, data, params) {
    return client.post(
      `/api/organizations/${store.state.organization.id}/goals/${id}/attachments/`,
      { ...data, delete: true },
      { params: params }
    )
  }

  addAttachmentsToInteraction(id, data, params) {
    return client.post(`/api/organizations/${store.state.organization.id}/interactions/${id}/attachments/`, data, {
      params: params,
      headers: { "Content-Type": "multipart/form-data" }
    })
  }
  deleteAttachmentsFromInteraction(id, data, params) {
    return client.post(
      `/api/organizations/${store.state.organization.id}/interactions/${id}/attachments/`,
      { ...data, delete: true },
      { params: params }
    )
  }

  addAttachmentsToTask(id, data, params) {
    return client.post(`/api/organizations/${store.state.organization.id}/tasks/${id}/attachments/`, data, {
      params: params,
      headers: { "Content-Type": "multipart/form-data" }
    })
  }

  getAttachment(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/attachments/${id}`, { params: params })
  }

  getAttachments(data, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/attachments/`, data, { params: params })
  }

  getAttachmentsByIds(ids, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/attachments/?ids=${ids}`, { params: params })
  }

  addAttachment(data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/attachments/`, data, {
      params: params,
      headers: { "Content-Type": "multipart/form-data" }
    })
  }

  updateAttachment(id, data, params = {}) {
    return client.patch(`/api/organizations/${store.state.organization.id}/attachments/${id}/`, data, {
      params: params,
      headers: { "Content-Type": "multipart/form-data" }
    })
  }
  deleteAttachmentsFromTask(id, data, params) {
    return client.post(
      `/api/organizations/${store.state.organization.id}/tasks/${id}/attachments/`,
      { ...data, delete: true },
      { params: params }
    )
  }

  getNoteCategories(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/notes-categories/`, { params: params })
  }

  createNoteCategory(data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/notes-categories/`, data, { params: params })
  }

  getNotes(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/record-notes/`, { params: params })
  }

  getNote(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/record-notes/${id}/`, { params: params })
  }

  addNote(data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/record-notes/`, data, { params: params })
  }

  updateNote(id, data, params = {}) {
    return client.patch(`/api/organizations/${store.state.organization.id}/record-notes/${id}/`, data, { params: params })
  }
  deleteNote(id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/record-notes/${id}/`)
  }

  updatePlan(id, data, params = {}) {
    return client.patch(`/api/organizations/${store.state.organization.id}/plans/${id}/`, data, { params })
  }

  // Interactions endpoint

  getAllInteractions(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/interactions/`, { params })
  }
  getEmailsSummary() {
    return client.get(`/api/organizations/${store.state.organization.id}/interactions/emails-summary/`)
  }

  getInteractions(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/records/${id}/interactions/`, { params })
  }
  getWhatsAppMessages(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/interactions/whatsapp/`, { params })
  }
  getInteraction(id) {
    return client.get(`/api/organizations/${store.state.organization.id}/interactions/${id}/`)
  }
  removeInteraction(id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/interactions/${id}/`)
  }
  createInteraction(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/interactions/`, data)
  }
  bulkInteractionCreate(data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/interactions/bulk-interaction-create/`, data, { params })
  }
  updateInteraction(id, data) {
    return client.patch(`/api/organizations/${store.state.organization.id}/interactions/${id}/`, data)
  }

  // Tasks endpoint
  getTasks(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/tasks/`, { params })
  }

  // Calendar endpoint
  getCalendarActivities(params) {
    return client.get(`/api/organizations/${store.state.organization.id}/calendar/`, { params })
  }

  getTask(id) {
    return client.get(`/api/organizations/${store.state.organization.id}/tasks/${id}/`)
  }
  removeTask(id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/tasks/${id}/`)
  }
  createTask(data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/tasks/`, data, { params })
  }
  bulkTaskCreate(data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/tasks/bulk-task-create/`, data, { params })
  }
  updateTask(id, data, params = {}) {
    return client.patch(`/api/organizations/${store.state.organization.id}/tasks/${id}/`, data, { params })
  }
  /* Graphs */
  getGraphs(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/graphs/`, { params })
  }
  getAllGraphsFlat() {
    return client.get(`/api/organizations/${store.state.organization.id}/graphs/all-graphs/`)
  }
  getGraph(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/graphs/${id}/`, { params })
  }
  removeGraph(id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/graphs/${id}/`)
  }
  getGraphData(id, data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/graphs/${id}/records/`, data, { params })
  }
  createGraph(data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/graphs/`, data, { params })
  }

  updateGraph(id, data, params = {}) {
    return client.patch(`/api/organizations/${store.state.organization.id}/graphs/${id}/`, data, { params })
  }

  // forecast endpoints
  getForecasts(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/forecasts/`, { params })
  }

  getForecast(forecast_id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/forecasts/${forecast_id}/`, { params })
  }

  getForecastsStats(forecast_id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/forecasts/${forecast_id}/get-forecasts-stats/`, { params })
  }
  updateForecast(forecast_id, data, params = {}) {
    return client.patch(`/api/organizations/${store.state.organization.id}/forecasts/${forecast_id}/`, data, { params })
  }

  getAllHiddenCompaniesForecast(forecast_id, params = {}) {
    return client.get(
      `/api/organizations/${store.state.organization.id}/forecasts/${forecast_id}/records-forecast/get-all-hidden-forecasts/`,
      { params }
    )
  }
  updateRecordForecast(forecast_id, id, data, params = {}) {
    return client.patch(`/api/organizations/${store.state.organization.id}/forecasts/${forecast_id}/records-forecast/${id}/`, data, {
      params
    })
  }
  addCompanyForecast(forecast_id, data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/forecasts/${forecast_id}/records-forecast/`, data, { params })
  }
  removeCompanyForecast(forecast_id, id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/forecasts/${forecast_id}/records-forecast/${id}/`)
  }
  hideCompanyForecast(forecast_id, id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/forecasts/${forecast_id}/records-forecast/${id}/hide/`, data)
  }
  showHiddenCompanyForecast(forecast_id, id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/forecasts/${forecast_id}/records-forecast/${id}/show/`, data)
  }
  findForecastCompaniesByFilters(forecast_id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/forecasts/${forecast_id}/records-forecast/`, { params })
  }
  findBaseForecastsByFilters(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/forecasts/records-forecast/`, { params })
  }
  getForeCastChecklist(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/forecast-checklists/`, { params })
  }
  createForeCastChecklist(data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/forecast-checklists/`, data, { params })
  }
  updateForeCastChecklist(id, data) {
    return client.patch(`/api/organizations/${store.state.organization.id}/forecast-checklists/${id}/`, data)
  }
  deleteForeCastChecklist(id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/forecast-checklists/${id}/`)
  }
  getForecastNotes(forecast_id, id) {
    return client.get(`/api/organizations/${store.state.organization.id}/forecasts/${forecast_id}/records-forecast/${id}/notes/`)
  }
  addNoteToForecast(forecast_id, id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/forecasts/${forecast_id}/records-forecast/${id}/notes/`, data)
  }
  updateForecastNote(forecast_id, id, note_id, data) {
    return client.patch(
      `/api/organizations/${store.state.organization.id}/forecasts/${forecast_id}/records-forecast/${id}/notes/${note_id}/`,
      data
    )
  }
  deleteForecastNote(forecast_id, id, note_id) {
    return client.delete(
      `/api/organizations/${store.state.organization.id}/forecasts/${forecast_id}/records-forecast/${id}/notes/${note_id}/`
    )
  }

  getCompanyCompetitors(id, params = { page_size: 50 }) {
    return client.get(`/api/organizations/${store.state.organization.id}/records/${id}/competitors/`, { params })
  }
  getCompanyInsights(id, params = { page_size: 50 }) {
    return client.get(`/api/organizations/${store.state.organization.id}/records/${id}/insights/`, { params })
  }

  getCompetitorCompanyInsights(data, params = { page_size: 50 }) {
    return client.post(`/api/organizations/${store.state.organization.id}/records/insights/`, data, { params })
  }
  getCompanyInfo(domain_name, name, data, params = { page_size: 50 }) {
    return client.get(`/api/ai/insights/?domain=${domain_name}&name=${name}`, data, { params })
  }

  getRecordInsights(id, params = { page_size: 50, is_async: true }) {
    return client.get(`/api/organizations/${store.state.organization.id}/records/${id}/full-insights/`, { params })
  }

  getCompetitorCompanyCompetitors(data, params = { page_size: 50 }) {
    return client.post(`/api/organizations/${store.state.organization.id}/records/competitors/`, data, { params })
  }

  getCompanySummary(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/records/${id}/summary/`, { params })
  }
  getCompetitorCompanySummary(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/records/summary/`, data)
  }

  getRecordMap(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/records/${id}/record-map/`, { params })
  }
  getRecordGoals(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/records/${id}/goals/`, { params })
  }
  getRecordPlans(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/plans/`, { params })
  }
  getRecordTasks(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/records/${id}/tasks/`, { params })
  }
  getRecordNotes(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/records/${id}/record-notes/`, { params })
  }
  addNoteToRecord(id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/records/${id}/record-notes/`, data)
  }
  updateRecordNote(id, note_id, data) {
    return client.patch(`/api/organizations/${store.state.organization.id}/records/${id}/record-notes/${note_id}/`, data)
  }
  deleteRecordNote(id, note_id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/records/${id}/record-notes/${note_id}/`)
  }
  getRecordsRollupMetrics(data = { records_ids: [], metrics_ids: [] }) {
    return client.post(`/api/organizations/${store.state.organization.id}/records/rollup-metrics/`, data)
  }

  getPlanGoals(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/plans/${id}/goals/`, { params })
  }

  getPlanTasks(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/plans/${id}/tasks/`, { params })
  }

  getGoalTasks(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/goals/${id}/tasks/`, { params })
  }

  getInteractionTasks(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/interactions/${id}/tasks/`, { params })
  }

  getPlanNotes(id, params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/plans/${id}/notes/`, { params })
  }

  addGoalToPlan(id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/plans/${id}/add-goals/`, data)
  }
  addTaskToPlan(id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/plans/${id}/add-tasks/`, data)
  }

  addTaskToGoal(id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/goals/${id}/add-tasks/`, data)
  }
  addTaskToInteraction(id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/interactions/${id}/add-tasks/`, data)
  }
  addNoteToPlan(id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/plans/${id}/add-notes/`, data)
  }

  removeGoalFromPlan(id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/plans/${id}/remove-goals/`, data)
  }
  removeTaskFromPlan(id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/plans/${id}/remove-tasks/`, data)
  }
  removeTaskFromGoal(id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/goals/${id}/remove-tasks/`, data)
  }
  removeTaskFromInteraction(id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/interactions/${id}/remove-tasks/`, data)
  }
  removeNoteFromPlan(id, data) {
    return client.post(`/api/organizations/${store.state.organization.id}/plans/${id}/remove-notes/`, data)
  }

  getRollupMetrics(data, params = {}) {
    return client.patch(`/api/organizations/${store.state.organization.id}/records/rollups/`, data, { params })
  }

  getMetricsHistoryValues(data, params = {}) {
    return client.post(`/api/organizations/${store.state.organization.id}/records/history/`, data, { params })
  }

  getMatrixCompanies(params = { type: "growth_matrix", page_size: 25 }) {
    return client.get(`/api/organizations/${store.state.organization.id}/matrices/get-matrix/`, { params })
  }

  getOneMatrixCompanies(id, params = { type: "growth_matrix", page_size: 25 }) {
    return client.get(`/api/organizations/${store.state.organization.id}/matrices/${id}/get-matrix/`, { params })
  }

  deleteMatrix(id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/matrices/${id}/`)
  }

  updateMatrix(id, data) {
    return client.patch(`/api/organizations/${store.state.organization.id}/matrices/${id}/`, data)
  }

  getNewLeads(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/matrices/new-leads/`, { params })
  }

  // phases
  getJourney(id = "primary", params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/phases-groups/${id}/`, { params })
  }
  deleteJourney(id = "primary") {
    return client.delete(`/api/organizations/${store.state.organization.id}/phases-groups/${id}/`)
  }
  getJourneys(params) {
    return client.get(`/api/organizations/${store.state.organization.id}/phases-groups/`, { params })
  }
  addJourney(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/phases-groups/`, data)
  }
  updateJourney(id = "primary", data) {
    return client.patch(`/api/organizations/${store.state.organization.id}/phases-groups/${id}/`, data)
  }
  duplicateJourney(id) {
    return client.post(`/api/organizations/${store.state.organization.id}/phases-groups/${id}/duplicate/`)
  }

  sendEmail(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/records/send-email/`, data, {
      headers: { "Content-Type": "multipart/form-data" }
    })
  }

  getEmails() {
    return client.get(`/api/organizations/${store.state.organization.id}/records/get-emails/`)
  }

  getNestedObjectsForCompany(id, params) {
    return client.get(`/api/organizations/${store.state.organization.id}/records/${id}/nested-objects/`, { params })
  }

  getNestedObjectsForGroup(id, params) {
    return client.get(`/api/organizations/${store.state.organization.id}/groups/${id}/nested-objects/`, { params })
  }

  getEvents() {
    return client.get(`/api/organizations/${store.state.organization.id}/records/get-events/`)
  }

  createPhase(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/phases/`, data)
  }

  duplicatePhase(id) {
    return client.post(`/api/organizations/${store.state.organization.id}/phases/${id}/duplicate/`)
  }

  getWorkspaces(params = { page_size: 6 }) {
    return client.get(`/api/organizations/${store.state.organization.id}/workspaces/`, { params })
  }

  getWorkspaceCollaborators(params = { q: "" }) {
    return client.get(`/api/organizations/${store.state.organization.id}/workspaces/collaborators/`, { params })
  }

  getMyWorkspaceOrganizations() {
    return client.get(`/api/organizations/${store.state.organization.id}/workspaces/my-organizations/`)
  }

  getWorkspace(id) {
    return client.get(`/api/organizations/${store.state.organization.id}/workspaces/${id}/`)
  }

  createWorkspace(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/workspaces/`, data)
  }

  deleteWorkspace(id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/workspaces/${id}`)
  }

  updateWorkspace(data) {
    if (data.team_members || data.contacts || data.layout) {
      return client.patch(`/api/organizations/${store.state.organization.id}/workspaces/${data.short_id}/`, data)
    } else {
      return client.patch(`/api/organizations/${store.state.organization.id}/workspaces/${data.short_id}/`, data, {
        headers: { "Content-Type": "multipart/form-data" }
      })
    }
  }

  updateWorkspaceTeamMemberAccessScope(data) {
    const short_id = data.short_id
    delete data.short_id
    return client.post(`/api/organizations/${store.state.organization.id}/workspaces/${short_id}/update-team-member-access-scope/`, data)
  }

  updateWorkspaceContactAccessScope(data) {
    const short_id = data.short_id
    delete data.short_id
    return client.post(`/api/organizations/${store.state.organization.id}/workspaces/${short_id}/update-contact-access-scope/`, data)
  }

  addWorkspaceTeamMember(data) {
    const short_id = data.short_id
    delete data.short_id
    return client.post(`/api/organizations/${store.state.organization.id}/workspaces/${short_id}/add-team-member/`, data)
  }

  removeWorkspaceTeamMember(data) {
    const short_id = data.short_id
    delete data.short_id
    return client.post(`/api/organizations/${store.state.organization.id}/workspaces/${short_id}/remove-team-member/`, data)
  }

  addWorkspaceCollaborator(data) {
    const short_id = data.short_id
    delete data.short_id
    return client.post(`/api/organizations/${store.state.organization.id}/workspaces/${short_id}/add-contact/`, data)
  }

  removeWorkspaceCollaborator(data) {
    const short_id = data.short_id
    delete data.short_id
    return client.post(`/api/organizations/${store.state.organization.id}/workspaces/${short_id}/remove-contact/`, data)
  }

  editPhase(data, id) {
    return client.patch(`/api/organizations/${store.state.organization.id}/phases/${id}/`, data)
  }

  getPhase(id) {
    return client.get(`/api/organizations/${store.state.organization.id}/phases/${id}/`)
  }
  removePhase(id) {
    return client.delete(`/api/organizations/${store.state.organization.id}/phases/${id}/`)
  }
  getPhases() {
    return client.get(`/api/organizations/${store.state.organization.id}/phases/`)
  }

  getActivities(params = {}) {
    return client.get(`/api/organizations/${store.state.organization.id}/activities/`, { params })
  }
  deleteActivity(id) {
    return client.get(`/api/organizations/${store.state.organization.id}/activities/${id}/`)
  }

  //used before BE endpoint is ready
  testRequest() {
    return client.get(`/api/organizations/${store.state.organization.id}/phases/`)
  }

  submitSurvey(org_id, record_id, score_id, data) {
    return client.post(`/api/organizations/${org_id}/survey/${record_id}/${score_id}/`, data)
  }
  getSurvey(org_id, record_id, score_id) {
    return client.get(`/api/organizations/${org_id}/survey/${record_id}/${score_id}/`)
  }
  /* Notifications */

  getNotifications(id, params = {}) {
    return client.get(`/api/users/${id}/notifications/`, { params })
  }

  markNotificationAsSeen(id, not_id, params = {}) {
    return client.get(`/api/users/${id}/notifications/${not_id}/mark-as-seen/`, { params })
  }

  markAllNotificationAsSeen(id, params = {}) {
    return client.get(`/api/users/${id}/notifications/mark-all-as-seen/`, { params })
  }

  markNotificationAsUnSeen(id, not_id, params = {}) {
    return client.get(`/api/users/${id}/notifications/${not_id}/mark-as-unseen/`, { params })
  }

  /**
   * EndPoint to sign storage post request
   */
  signS3PostRequest(data) {
    return client.post("/api/sign-s3/", data)
  }
  uploadLinkToS3(data) {
    return client.post("/api/upload-link-to-s3/", data)
  }
  /**
   * Upload file to storage bucket
   */
  uploadFileToS3(url, file, headers = {}) {
    return axios.put(url, file, headers)
  }

  prompt(prompt, context_messages = null) {
    return client.post("/api/ai/chat/", { prompt: prompt, context_messages: context_messages })
  }

  get(url, params = {}) {
    return client.get(url, { params })
  }

  post(url, data, params = {}) {
    return client.post(url, data, { params })
  }

  //Feedback
  submitFeedback(data) {
    return client.post(`/api/organizations/${store.state.organization.id}/feedback/`, data)
  }
}

export default new DataService()
